import React from "react";
import { Table } from "react-bootstrap";
import { formatCurrency } from "../../utils";
import { useTranslation } from "react-i18next";

function CartSummary({ totalPrice, shippingCost, totalPriceWithShippingCost, totalQuantityHeader }) {
  const { t } = useTranslation();

  if (totalQuantityHeader === 0) return null;

  return (
    <Table striped hover variant="light">
      <tbody>
        <tr>
          <td>Subtotal ({t("items")}):</td>
          <td style={{ textAlign: "right" }}>
            {formatCurrency(totalPrice)} ({totalQuantityHeader})
          </td>
        </tr>
        <tr>
          <td>{t("shipping_cost")}:</td>
          <td style={{ textAlign: "right" }}>
            {formatCurrency(shippingCost)}
          </td>
        </tr>
        <tr>
          <td>{t("total")}:</td>
          <td style={{ textAlign: "right" }}>
            {formatCurrency(totalPriceWithShippingCost)}
          </td>
        </tr>
      </tbody>
    </Table>
  );
}

export default CartSummary;
